<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form  [form]="form">
        </sm-form>
        <p-button icon="fas fa-cog" label="Holen" (onClick)="get()"></p-button>
    </p-panel>
    <div class="flex-item-fill">
        <textarea pInputTextarea spellcheck=false class="width100p height100p monospace no-resize" [ngModel]="result"></textarea>
    </div>
</div>
